import Vue from 'vue'
import Vuex from 'vuex'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  state: {
    currentLanguage: 'ja',
    languageOptions: {
      ja: '日本語',
      en: 'English',
      zh: '中文'
    }
  },
  mutations: {
    setCurrentLanguage (state, language) {
      state.currentLanguage = language
      localStorage.setItem('selectedLanguage', language)
    },
    restoreLanguage (state) {
      const selectedLanguage = localStorage.getItem('selectedLanguage')
      if (selectedLanguage) {
        state.currentLanguage = selectedLanguage
      }
    }
  },
  actions: {
    changeLanguage ({ commit }, language) {
      commit('setCurrentLanguage', language)
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
